// removed by extract-text-webpack-plugin
module.exports = {"PageSection":"_2A8cFf6nIWe6ALGt-R1HwG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PageSection/PageSection.scss
// module id = 2656
// module chunks = 0